var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "TA Configuration",
        visible: _vm.dialogVisible,
        scrollbar: false,
        width: "700px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.onOpen,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-button",
        {
          attrs: { type: "primary", icon: "el-icon-plus" },
          on: {
            click: function ($event) {
              return _vm.handleAdd()
            },
          },
        },
        [_vm._v(" Add ")]
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.taListLoading,
              expression: "taListLoading",
            },
          ],
          attrs: {
            data: _vm.tableTAList,
            "element-loading-text": "Loading...",
            "header-row-class-name": "table-header",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "taConfigName",
              label: "TA NAME",
              "min-width": "250",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "Status", "min-width": "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        disabled: "",
                        "active-color": "#d52b1e",
                        "inactive-color": "#f2f3f6",
                      },
                      model: {
                        value: row.status,
                        callback: function ($$v) {
                          _vm.$set(row, "status", $$v)
                        },
                        expression: "row.status",
                      },
                    }),
                    _vm._v(" " + _vm._s(row.status ? "可用" : "不可用") + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "options",
              label: "Operation",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v(" 编辑 ")]
                    ),
                    _vm._v("| "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [_vm._v(" 删除 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }